"use client";

// GET /api/admin/leaderboards/managers.

import { adminApi } from "../lib/api";
import LeaderboardPanel from "./LeaderboardPanel";

export default function ManagerLeaderboard() {
  return (
    <LeaderboardPanel
      title="Manager Performance"
      subtitle="ranked by close rate"
      emptyTitle="No managers ranked yet"
      fetcher={(signal) => adminApi.managerLeaderboard({ limit: 10 }, signal)}
    />
  );
}
